export default "__VITE_ASSET__DUXj_D8B__"